import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const CodeSnippet = (props) => {
    const [html, setHtml] = useState(props.html || '<div></div>');

    const divRef = React.createRef();

    useEffect(() => {
        if (document && html && divRef.current) {
            // Create a 'tiny' document and parse the html string
            const fragment = document.createRange().createContextualFragment(html);
            // Clear the container
            divRef.current.innerHTML = '';
            // Append the new content
            divRef.current.appendChild(fragment);
        }

        return () => {};
    }, [divRef, html]);

    return (
        <div ref={divRef} />
    );
};

/* =========================================================================  */
/* Typing and exports */
/* =========================================================================  */

const propTypes = {
    html: PropTypes.string.isRequired
};

CodeSnippet.propTypes = propTypes;

export { CodeSnippet };

export default CodeSnippet;
